import './SuggestLoginForm.css';
import { BaseSyntheticEvent, useState } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { Button } from './Button';
import { TextInput } from './TextInput';
import { useSession } from '../../state/session';
import { ForgotPasswordButton } from './ForgotPasswordButton';

export function LoginForm({ email }: { email: string }) {
	const [password, setPassword] = useState<string>('');
	const [wantsContactInfoByEmail, setWantsContactInfoByEmail] = useState(false);
	const [failedLogin, setFailedLogin] = useState(false);
	const { login } = useSession();
	const t = useTranslation().form;

	async function handleLoginSubmit(e: BaseSyntheticEvent, email: string, password: string) {
		e.preventDefault();
		const { success } = await login(email, password);
		setFailedLogin(!success);
		if (success) {
			window.location.reload();
		}
	}

	return (
		<div className="suggest-login-info">
			<p>{t.youAlreadyHaveAnAccount}</p>
			<p>
				<input
					type="checkbox"
					id="fillOutPassword"
					name="fillOutPassword"
					onChange={(e) => setWantsContactInfoByEmail(e.target.checked)}
				/>
				<label htmlFor="fillOutPassword"> {t.iWantToFillOutPassword}</label>
			</p>
			{failedLogin && <p className="login-failed-text">{t.wrongPasswordTryAgain}</p>}

			{wantsContactInfoByEmail && (
				<p className="checkout-login-form">
					<div className="inputs">
						<TextInput
							type="password"
							placeholder={t.password}
							onChange={(e) => setPassword(e.target.value)}
						/>
						<Button onClick={(e) => handleLoginSubmit(e, email, password)}>{t.login}</Button>
					</div>
					<ForgotPasswordButton email={email} />
				</p>
			)}
		</div>
	);
}
